import React, { useEffect, useMemo, useState } from "react"
import { Form, Button, Upload, message, notification } from "antd"
import type { UploadFile } from 'antd/es/upload/interface';
import { InboxOutlined } from '@ant-design/icons';
import "./addBp.css"
import { addBp } from "../../api/BPTable/BPTableMethods";
import template from "../../assets/Template_Ajout_BP.CSV"

const { Dragger } = Upload;

const uploadLayout = {
  wrapperCol: { offset: 7, span: 16 },
}

function AddBp() {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [error, setError] = useState<string | undefined>(undefined)

  const [form] = Form.useForm();

  useEffect(() => {
  }, [])

  const validateFileType = (
    { type, name }: UploadFile,
    allowedTypes?: string
  ) => {
    if (!allowedTypes) {
      return true;
    }

    if (type) {
      return allowedTypes.includes(type);
    }
  };

  const uploadProps = useMemo(
    () => ({
      beforeUpload: (file: UploadFile) => {
        const isAllowedType = validateFileType(file, "text/csv");
        if (!isAllowedType) {
          setFileList((state) => [...state]);
          message.error("Le fichier n'est pas au format CVS, veuillez réessayer");
          return false;
        }
        setFileList([file]);
        return false;
      },
      onRemove: (file: UploadFile) => {
        if (fileList.some((item) => item.uid === file.uid)) {
          setFileList((fileList) =>
            fileList.filter((item) => item.uid !== file.uid)
          );
          return true;
        }
        return false;
      }
    }),
    [fileList]
  );

  const onFinish = async () => {
    const data = await new Promise<string[] | undefined>((resolve, reject) => {
      let list: any = []
      fileList.forEach((elem: any) => {
        let reader = new FileReader();
        if (reader) {
          reader.onload = ((event: any) => {
            list.push(event.target.result)
            if (list.length === fileList.length)
              resolve(list)
          })
          reader.readAsText(elem);
        }
      })
    })
    if (data) {
      const res = await addBp(data)
      if (res.result) {
        const count = res.result.length
        if (count > 1)
          message.success({ content: `${count} BP ont été aujoutés`, duration: 5 })
        else
          message.success({ content: `${count} BP a été aujouté`, duration: 5 })
      } else if (res.response.status === 400 && res.response.statusText) {
        notification.error({ message: res.response.statusText, duration: 0 })
        setFileList([])
      } else if (res?.response?.status === 403 && res?.response?.data) {
        notification.error({ message: `${res.response.data.message}\nSKU: ${res.response.data.list}`, duration: 0 })
        console.log(res.response.data.message)
      }
    }
  }

  const onFinishFailed = (errors: any) => {
  }

  const handleDownload = () => {
    const csvContent = "N° BP;SKU;Libellé Article;Total\n3089648;077059CJ37;BRACELET MONTRE AWH ST45 SWIFT GOLD;700"
    var universalBOM = "\uFEFF";
    var a = window.document.createElement('a');
    a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvContent));
    a.setAttribute('download', "template_d'ajout_de_BP.CSV");
    window.document.body.appendChild(a);
    a.click();
  }

  return (
    <>
      <div style={{ paddingLeft: '5rem', paddingTop: '2rem' }}>
        <h1>Ajout de BP</h1>
      </div>
      <div style={{ width: "100%", alignContent: 'center', alignItems: 'center', paddingTop: "5%" }}>
        <div className="template-bp-div">
          <a
            onClick={handleDownload}
            style={{ textDecoration: "underline" }}
            download="Template_Ajout_BP.CSV"
            target='_blank' rel="noreferrer">
            Telecharger un template
          </a>
        </div>
        <Form
          form={form}
          name="basic"
          style={{ width: "80%" }}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 28 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item  {...uploadLayout}>
            <Dragger customRequest={({ file, onSuccess }) => {
              if (onSuccess) {
                onSuccess("ok");
              }
            }} {...uploadProps} fileList={fileList}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Cliquer ou glisser un CSV dans cette zone</p>
            </Dragger>
          </Form.Item>
          <div style={{ width: '100%', position: 'absolute', textAlign: 'center' }}>
            <Button className="form-button" htmlType="submit">
              Confirmer
            </Button>
          </div>
        </Form>
      </div>
    </>
  )
}

export default AddBp